import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { RouteNavbar } from '@shared/components/navigation/interfaces/routes-navbar';

@Component({
  selector: 'app-tabs',
  imports: [NgIcon, RouterLink, RouterLinkActive, NgClass],
  templateUrl: './tabs.html',
  styleUrl: './tabs.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Tabs {
  route = input.required<RouteNavbar>();
  alignStart = input<boolean>(false);
}
